import { render, staticRenderFns } from "./ChatPostDialog.vue?vue&type=template&id=0fa5269a"
import script from "./ChatPostDialog.vue?vue&type=script&lang=js"
export * from "./ChatPostDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatPostDialog.vue?vue&type=style&index=0&id=0fa5269a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports